/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Soft_Bronze_Trout_ScanInputs */

const en_soft_bronze_trout_scan = /** @type {(inputs: Soft_Bronze_Trout_ScanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Available`)
};

const de_soft_bronze_trout_scan = /** @type {(inputs: Soft_Bronze_Trout_ScanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfügbar`)
};

/**
* | output |
* | --- |
* | "Available" |
*
* @param {Soft_Bronze_Trout_ScanInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const soft_bronze_trout_scan = /** @type {((inputs?: Soft_Bronze_Trout_ScanInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Soft_Bronze_Trout_ScanInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_soft_bronze_trout_scan(inputs)
	return de_soft_bronze_trout_scan(inputs)
});